// extracted by mini-css-extract-plugin
module.exports = {"Link":"Social_Link__3XHMH","Container":"Social_Container__3Uyuu"};